/** Pakistan cities list - use for city dropdown wherever address is collected */
const cities = [
  'Islamabad', 'Karachi', 'Lahore', 'Rawalpindi', 'Faisalabad', 'Multan', 'Hyderabad', 'Peshawar', 'Quetta',
  'Gujranwala', 'Sialkot', 'Bahawalpur', 'Sargodha', 'Sukkur', 'Larkana', 'Sheikhupura', 'Rahim Yar Khan', 'Jhang',
  'Gujrat', 'Kasur', 'Mardan', 'Mingora', 'Dera Ghazi Khan', 'Nawabshah', 'Mirpur Khas', 'Jacobabad', 'Shikarpur',
  'Khairpur', 'Thatta', 'Badin', 'Umerkot', 'Tando Adam', 'Tando Allahyar', 'Dadu', 'Naushahro Feroze', 'Kandhkot',
  'Kashmore', 'Ghotki', 'Rohri', 'Hala', 'Matiari', 'Sanghar', 'Jamshoro', 'Abbottabad', 'Mansehra', 'Haripur',
  'Swabi', 'Charsadda', 'Nowshera', 'Kohat', 'Bannu', 'Dera Ismail Khan', 'Tank', 'Hangu', 'Lakki Marwat', 'Batkhela',
  'Lower Dir', 'Upper Dir', 'Chitral', 'Parachinar', 'Muzaffarabad', 'Mirpur', 'Kotli', 'Bhimber', 'Rawalakot',
  'Gilgit', 'Skardu', 'Hunza', 'Diamer', 'Ghizer', 'Okara', 'Sahiwal', 'Vehari', 'Pakpattan', 'Chiniot', 'Toba Tek Singh',
  'Mianwali', 'Bhakkar', 'Khushab', 'Narowal', 'Nankana Sahib', 'Hafizabad', 'Lodhran', 'Khanewal', 'Rajanpur',
  'Attock', 'Chakwal', 'Jhelum', 'Mandi Bahauddin', 'Zhob', 'Loralai', 'Khuzdar', 'Turbat', 'Gwadar', 'Panjgur',
  'Kalat', 'Mastung', 'Kharan', 'Washuk', 'Awaran', 'Dera Bugti', 'Sibi', 'Naseerabad'
];

export default { cities };
export { cities };
